const distanceBetween = (p1, p2) =>
  Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));

const centerOfRectangle = (rect, left = rect.left, top = rect.top) => ({
  x: left + rect.width * 0.5,
  y: top + rect.height * 0.5,
});

const matchType = (draggable, droppable) =>
  droppable.data.current.accepts.includes(draggable.data.current.type);

const matchDirection = (direction, droppable, reference) => {
  const matchX = () =>
    reference.x > droppable.left &&
    reference.x < droppable.left + droppable.width;

  const matchY = () =>
    reference.y > droppable.top &&
    reference.y < droppable.top + droppable.height;

  if (direction === "vertical") return matchX();
  else if (direction === "horizontal") return matchY();

  return true;
};
export const closestCenter =
  ({ active }) =>
  ({
    collisionRect,
    droppableRects,
    droppableContainers,
    pointerCoordinates,
  }) => {
    const direction = active.data.current?.direction;
    const centerRect = centerOfRectangle(
      collisionRect,
      collisionRect.left,
      collisionRect.top
    );

    let minDistance = Number.POSITIVE_INFINITY;
    let collision = { id: undefined };

    // eslint-disable-next-line @bigbinary/neeto/use-array-methods
    for (const droppableContainer of droppableContainers) {
      const rect = droppableRects.get(droppableContainer.id);

      if (!rect || droppableContainer.id === active.id) continue;
      else if (!matchType(active, droppableContainer)) continue;
      else if (!matchDirection(direction, rect, pointerCoordinates)) continue;

      const distance = distanceBetween(centerOfRectangle(rect), centerRect);
      if (distance < minDistance) {
        minDistance = distance;
        collision = {
          id: droppableContainer.id,
          data: { droppableContainer, value: distance },
        };
      }
    }

    return [collision];
  };
